import clsx from 'clsx';
import { toRem } from '../../utils/ui';

import './skeleton.scss';

export const Skeleton = (props: SkeletonProps) => {
  const { width, height, animate = true, trueWidth, trueHeight, borderRadius = 4 } = props;

  return (
    <div
      className="skeleton"
      style={{
        width: toRem(trueWidth || width),
        height: toRem(trueHeight || height),
      }}
    >
      <div
        className={clsx({ animate })}
        style={{
          width: toRem(width || trueWidth),
          height: toRem(height || trueHeight),
          borderRadius: toRem(borderRadius),
        }}
      />
    </div>
  );
};

interface SkeletonProps {
  animate?: boolean;
  width?: string | number;
  height?: string | number;
  trueWidth?: string | number;
  trueHeight?: string | number;
  borderRadius?: string | number;
}
